import styled from 'styled-components';
import { media } from '../../media';

const SiteContainer = styled.div`
  margin: 0 auto;
  max-width: 1280px;
  padding: 0 60px;
  width: 100%;

  ${media.tablet`
    padding: 0 32px;
  `};

  ${media.tabletSmall`
    padding: 0 20px;
  `};
`;

export default SiteContainer;



// WEBPACK FOOTER //
// ./src/core/layout/components/SiteContainer/SiteContainer.js